import { FunctionComponent, useState } from "react";
import Modal from "../../../../../../common/Modal/Modal";
import Label from "../../../../../../Label";
import { Icon } from "../../../../../../Icon";
import "./styles.scss";
import { DetailedCartItem } from "../../../../../../../context/CartContext/CartContext.api.types";
import Button from "../../../../../../common/Button";
import { useCart } from "../../../../../../../context/CartContext";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  cartDetailedItem: DetailedCartItem;
};
const RemoveItemModal: FunctionComponent<Props> = ({
  isOpen,
  onClose,
  cartDetailedItem,
}) => {
  const { product } = cartDetailedItem;
  const { removeFromCart } = useCart();

  const handleOnDelete = () => {
    removeFromCart(cartDetailedItem.variation.id);
    onClose();
    window.scrollTo(0, 0);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      children={
        <div className="remove-item-modal">
          <header className="remove-item-modal__header">
            <Label tag="h3" className="remove-item-modal__title">
              Eliminar producto
            </Label>
            <div onClick={onClose}>
              <Icon
                iconName="close_icon"
                className="remove-item-modal__close-icon"
              />
            </div>
          </header>
          <div className="remove-item-modal__content">
            <div className="remove-item-modal__details">
              <Label
                tag="p"
                variants="body1"
                className="remove-item-modal__details__description"
              >
                ¿Estás seguro de borrar este producto?
              </Label>
              <Label
                tag="p"
                variants="subtitle"
                className="remove-item-modal__details__title"
              >
                {product.title}
              </Label>
            </div>
            <div className="remove-item-modal__buttons">
              <Button
                applyNewSize
                modifier="tertiary"
                className="remove-item-modal__button--cancel"
                onClick={onClose}
              >
                Cancelar
              </Button>
              <Button
                applyNewSize
                className="remove-item-modal__button--delete"
                onClick={handleOnDelete}
                modifier="fifth"
              >
                Eliminar
              </Button>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default RemoveItemModal;
